import "../__snowpack__/link/packages/old-react/build/_dist_/index.js";
import * as reactComponents from "./react-components.js";
import actions from "./redux/actions.js";
import store from "./redux/store.js";
window.reactComponent = reactComponents;
window.reduxStore = store;
window.reduxActions = actions;
